
  import {defineComponent, PropType, reactive, toRefs, watch} from "vue";
  import CustomerOrdersUpcoming from "@/views/Customers/orders/CustomerOrdersUpcoming.vue";
  import CustomerOrdersPast from "@/views/Customers/orders/CustomerOrdersPast.vue";
  import router from "@/router";
  import Customer from "@/model/Customer";
  import PlanOrderDialog from "@/views/Customers/orders/PlanOrderDialog.vue";
  import CustomerOrderService, {CustomerOrder, CustomerOrderSummary} from "@/service/CustomerOrderService";
  import DateUtils from "@/DateUtils";

  export default defineComponent({
    name: "CustomerOrders",
    components: {
      PlanOrderDialog,
      CustomerOrdersUpcoming,
      CustomerOrdersPast
    },
    props: {
      customer: {
        type: Object as PropType<Customer>,
        default: () => new Customer(),
      }
    },
    setup(props, context) {

      const initialState = {
        panel: [0, 1],
        loadingPast: false,
        loadingUpcoming: false,
        past: new Array<CustomerOrderSummary>(),
        upcoming: new Array<CustomerOrder>(),
        planOrderDialog: false,
        pastOrdersAvgPos: 0
      };
      const state = reactive({...initialState});

      const newOrder = () => {
        router.push({ path: `/orders/new?customerUuid=${props.customer.uuid}` });
      };
      const planOrder = () => {
        state.planOrderDialog = true;
      };
      const savePlanOrder = (positions: number) => {
        if (positions) {
          router.push({ path: `/v2/orders?customerUuid=${props.customer.uuid}&positions=${positions}` });
          state.planOrderDialog = false;
        }
      };
      const closePlanOrder = () => {
        state.planOrderDialog = false;
      };

      // The upcoming orders are the inventory orders starting today or later, the past ones those starting before
      watch(() => props.customer.uuid, customerUuid => {
        if (!customerUuid) {
          return;
        }
        const today = DateUtils.today();
        state.loadingUpcoming = true;
        CustomerOrderService.findInventoryOrdersStartingFrom(customerUuid, today)
          .then(response => {
            state.upcoming = response.data.orders;
          })
          .finally(() => state.loadingUpcoming = false);
        state.loadingPast = true;
        CustomerOrderService.findInventoryOrderSummariesStartingBefore(customerUuid, today)
          .then(response => {
            state.past = response.data.orderSummaries;
          })
          .finally(() => state.loadingPast = false);
      }, {immediate: true});

      const pastOrdersAvgPosChanged = (pastOrdersAvgPos: number) => {
        state.pastOrdersAvgPos = pastOrdersAvgPos;
      };

      return {
        ...toRefs(state),
        newOrder,
        planOrder,
        savePlanOrder,
        closePlanOrder,
        pastOrdersAvgPosChanged
      };
    }
  });
